export default "__VITE_ASSET__ee4a5d31__"